import storage from "src/helpers/storage";
import { STORAGE_KEYS } from "src/constants/common";

export function getRuntimeInfo() {
  return {
    app_version: storage.getItem(STORAGE_KEYS.APP_VERSION) ?? "web",
    app_build_number: storage.getItem(STORAGE_KEYS.BUILD_NUMBER) ?? "web",
    web_version: storage.getItem(STORAGE_KEYS.WEB_VERSION) ?? "unknown",
    platform: storage.getItem(STORAGE_KEYS.PLATFORM) ?? "web",
  };
}
